import { Box, Paper, Typography } from '@mui/material';
import { useAdminTenantDetails } from '@diggens/shared-hooks';

interface OverviewTabProps {
  tenant: any;
}

export function OverviewTab({ tenant }: OverviewTabProps) {
  const { data: details } = useAdminTenantDetails(tenant.id);

  const stats = [
    { label: 'Total Funds', value: details?.funds ?? 0 },
    { label: 'Admin Users', value: details?.admin_users ?? 0 },
    { label: 'Portfolio Company Users', value: details?.portco_users ?? 0 },
    { label: 'Total Users', value: details?.total_users ?? 0 },
    { label: 'Pending Approval', value: details?.pending_users ?? 0 },
    { label: 'Portfolio Companies', value: details?.portfolio_companies ?? 0 },
    { label: 'Submissions (30d)', value: details?.submissions_30d ?? 0 },
    { label: 'Metrics Tracked', value: details?.metrics ?? 0 },
  ];

  return (
    <Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 3, mb: 3 }}>
        {stats.map((stat) => (
          <Paper key={stat.label} sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h3" color="primary">
              {stat.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {stat.label}
            </Typography>
          </Paper>
        ))}
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Tenant Information
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Workspace Slug:</strong> {tenant.workspace_slug}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <strong>Workspace Email:</strong> {tenant.workspace_email}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <strong>Created:</strong> {new Date(tenant.created_at).toLocaleDateString()}
          </Typography>
        </Box>
      </Paper>

      {details && (
        <Paper sx={{ p: 3, mt: 3 }}>
          <Typography variant="h6" gutterBottom>
            Account
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Status:</strong> {details.account_status}
            </Typography>
            {details.trial_ends_at && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Trial Ends:</strong> {new Date(details.trial_ends_at).toLocaleDateString()}
              </Typography>
            )}
            {details.subscription_status && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Subscription:</strong> {details.subscription_status}
              </Typography>
            )}
            {details.subscription_owner && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Owner:</strong> {details.subscription_owner}
              </Typography>
            )}
          </Box>
        </Paper>
      )}
    </Box>
  );
}
